import { c as _c } from "react/compiler-runtime";
import SearchNoResult from "@website/accommodation-ui/villa-search/villa-search-panel/images/search-no-result.png";
import { useVillaSearchNoResult } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result/villa-search-no-result.hook";
import { VillaSearchNoResultPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result/villa-search-no-result.types";
import { LazyImage } from "@website/ui/lazy-image";
import { FC } from "react";
export const VillaSearchNoResult: FC<VillaSearchNoResultPropertiesType> = properties => {
  const $ = _c(14);
  const {
    resultTitle,
    notFoundtitle,
    firstDescription,
    secondDescription
  } = useVillaSearchNoResult(properties);
  let t0;
  if ($[0] !== resultTitle) {
    t0 = <div className="text-subtitle-2 text-on-surface-medium-emphasis w-full text-right">{resultTitle}</div>;
    $[0] = resultTitle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LazyImage alt="no result" loading="eager" src={SearchNoResult.src} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== notFoundtitle) {
    t2 = <div className="text-subtitle-1 text-on-surface-high-emphasis mt-6">{notFoundtitle}</div>;
    $[3] = notFoundtitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== firstDescription) {
    t3 = <div className="text-caption text-on-surface-medium-emphasis mt-2">{firstDescription}</div>;
    $[5] = firstDescription;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== secondDescription) {
    t4 = <div className="text-caption text-on-surface-medium-emphasis mt-2">{secondDescription}</div>;
    $[7] = secondDescription;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t0 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <div className="my-6 flex flex-col items-center px-6">{t0}{t1}{t2}{t3}{t4}</div>;
    $[9] = t0;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};